import React from 'react';
import { Grid, Paper, Typography, Button, CircularProgress } from '@mui/material';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';

const Container = styled(Grid)(({ theme }) => ({
    height: '100vh',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    position: 'absolute',
    top: 0,
    left: 0,
}));

const ContentContainer = styled(Grid)(({ theme }) => ({
    height: 'calc(100vh - 104px)',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.secondary.main,
    position: 'absolute',
    top: '104px',
    left: 0,
}));

const PaperRoot = styled(Paper)(({ theme }) => ({
    // boxShadow: theme.customShadows.widgetDark,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(8),
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    maxWidth: 404,
}));

const TextRow = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(5),
    textAlign: 'center',
}));

const ErrorCode = styled(Typography)(({ theme }) => ({
    fontWeight: 600,
    marginTop: theme.spacing(5),
}));

const BackButton = styled(Button)(({ theme }) => ({
    // boxShadow: theme.customShadows.widget,
    textTransform: 'none',
    fontSize: 16,
}));

const Content = () => {
    return (
        <PaperRoot>
            <ErrorCode variant="h3" color="secondary">
                404
            </ErrorCode>
            <TextRow variant="h6" color="primary">
                Ops. Página não encontrada!
            </TextRow>
            <BackButton variant="contained" color="primary" component={Link} to="/" size="large">
                Voltar para Página Inicial
            </BackButton>
        </PaperRoot>
    );
};

export function Error() {
    return (
        <Container container>
            <Content />
        </Container>
    );
}

export function ErrorContent() {
    return (
        <ContentContainer container>
            <Content />
        </ContentContainer>
    );
}
